export const SET_USERS = 'userList'
export const FETCH_START = 'fetchStart'
export const FETCH_END = 'fetchEnd'
export const SET_STATUSES = 'setStatuses'
export const MATCH_STATUS_NAME = 'matchStatusName'

export const SET_ADMIN_DELIVERY_COMPANIES = 'setAdminDeliveryCompanies';
